<template>
  <div>
    <van-overlay class="mo" :show="isOpen" @click="isOpen = false" />
    <div class="bottomDialog" :class="isOpen?'open':'close'" v-if="isShow">
      <div class="d_footer">
        <h3 @click="isOpen=!isOpen">
          欢迎垂询
          <div class="arrow-down" v-if="isOpen">
            <van-icon name="arrow-down" />
          </div>
          <div class="arrow-up" v-else>
            <van-icon name="arrow-up" />
          </div>
        </h3>
        <p class="desc">欢迎关注官方微信“数说产业互联网”，阅读更多精彩文章。也可以扫描下方二维码添加关注。数说产业互联网将为您提供更多解决方案</p>
        <ul class="cont clear">
          <li @click="routerLink('/solution/0')">
            <div class="mask">
              <div class="desc">
                <p>乡村振兴数字化解决方案</p>
                <div class="link" >了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_01.png" alt />
          </li>
          <li @click="routerLink('/solution/1')">
            <div class="mask">
              <div class="desc">
                <p>农业单品行业大数据解决方案</p>
                <div class="link">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_02.png" alt />
          </li>
          <li @click="routerLink('/solution/2')">
            <div class="mask">
              <div class="desc">
                <p>农业链主企业数字 化解决方案</p>
                <div class="link">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_03.png" alt />
          </li>
          <li @click="routerLink('/solution/3')">
            <div class="mask">
              <div class="desc">
                <p>现代农业产业园数 字化解决方案</p>
                <div class="link">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_04.png" alt />
          </li>
          <li @click="routerLink('/solution/4')">
            <div class="mask">
              <div class="desc">
                <p>农产品区域公用品牌数字化解决方案</p>
                <div class="link">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_05.png" alt />
          </li>
          <li @click="routerLink('/solution/5')">
            <div class="mask">
              <div class="desc">
                <p>农产品批发市场/交易中心数字化解决方案</p>
                <div class="link">了解更多></div>
              </div>
            </div>
            <img src="@/assets/lib/images/sec4_06.png" alt />
          </li>
        </ul>
      </div>
      <fixed-footer></fixed-footer>
    </div>
  </div>
</template>

<script>
import fixedFooter from "@/layout/components/mob/GlobalFooter";
export default {
  components: {
    fixedFooter: fixedFooter,
  },

  props: ["isFixed"],

  data() {
    return {
      isOpen: false,
      isShow: true,
    };
  },

  watch: {
    isFixed(ev) {
      if (ev) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
  },
  methods: {
    routerLink(url) {
      this.$router.push(url);
    },
    }
};
</script>

<style lang="scss">
.mo.van-overlay {
  background-color: rgba(0, 0, 0, 0.3);
}
.bottomDialog {
  width: 100%;
  height: 11.2rem;
  position: fixed;
  bottom: -10rem;
  left: 0;
  overflow-y: auto;

  z-index: 2;
  &.open {
    transform: translateY(-10rem);
    transition: all 1s ease 0.1s;
  }
  &.close {
    transform: translateY(0rem);
    transition: all 1s ease 0.1s;
  }
}
</style>